import { render, staticRenderFns } from "./add-edit-company.vue?vue&type=template&id=c65804ec&scoped=true&"
import script from "./add-edit-company.vue?vue&type=script&lang=js&"
export * from "./add-edit-company.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-company.vue?vue&type=style&index=0&id=c65804ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65804ec",
  null
  
)

export default component.exports